import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de posologie du paracétamol pour enfants";
const DESCRIPTION =
  "Calculatrice de posologie du paracétamol pour enfants en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de posologie du paracétamol pour enfants, calculatrice de posologie du paracétamol pour enfants, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/children-paracetamol-dosage-calculator/";

function ParacetamolChildrenDosageCalculator() {
  const [weight, setWeight] = useState("");
  const [concentration, setConcentration] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateDosage = () => {
    try {
      if (weight < 44 && concentration) {
        let singleDose;
        const weightNum = parseFloat(weight);

        if (concentration === "160mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.25;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 1.87;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 2.5;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 3.75;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 5;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 7.5;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 10;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 12.5;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 15;
        } else if (concentration === "120mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.5;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.3;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 5;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.6;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 10;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 13.3;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16.6;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 20;
        } else if (concentration === "125mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.4;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.2;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 4.8;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.4;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 9.6;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 12.8;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 19.2;
        }

        const totalDose = singleDose * 5;
        setResult({
          singleDose,
          totalDose,
        });
      }

      if (weight > 43.9) {
        setError("Veuillez entrer un poids entre 2,7 et 43,9");
        return;
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculatrice de posologie quotidienne du paracétamol spécialement conçue pour les parents pour les aider à calculer avec précision la dose de paracétamol. Pas besoin de calculs complexes, il suffit d'entrer les données requises et d'obtenir la dose correcte. Sûr et fiable, parfait pour une utilisation à domicile.
                </p>
                <p>
                  Calculatrice facile à utiliser de dosage de paracétamol vous aide à déterminer la dose de médicament idéale pour votre enfant en fonction de son poids et de la concentration du médicament. Entrez les données requises et obtenez les dosages en détail. Idéal pour les parents et les médecins.
                </p>
                <p>
                  <b>
                    Remarque importante: il faut toujours souligner que cet outil est un outil d'aide uniquement et ne doit pas être utilisé à la place d'une consultation médicale.
                  </b>
                </p>
                <p>
                  La calculatrice a été développée sur la base de{" "}
                  <a
                    href="https://www.sfda.gov.sa/fr/paracetamol-calculator"
                    rel="nofollow"
                  >
                    l'Autorité générale pour l'alimentation et les médicaments en Arabie Saoudite
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">Entrez le poids (kg)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Entrez le poids de l'enfant"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="concentration">
                      <label className="form-label ms-2">
                        Sélectionnez la concentration
                      </label>
                      <select
                        id="concentration"
                        value={concentration}
                        onChange={(e) => setConcentration(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">-- Choisissez --</option>
                        <option value="160mg/5ml">160mg/5ml</option>
                        <option value="120mg/5ml">120mg/5ml</option>
                        <option value="125mg/5ml">125mg/5ml</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateDosage}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p className="text-white">Dose unique: {result.singleDose} ml</p>
                      <p className="text-white">Dose totale: {result.totalDose} ml</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Paractamol pour enfants</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Prcautions d'utilisation</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ParacetamolChildrenDosageCalculator;
